import React from 'react'
import CounterUp from './CounterGlobal';
function Counter() {
  return (
    <div>
        
        {/* tmp counterup section area start */}
        <div className="tmp-section-gapTop tmp-counterup-area pt-2">
            <div className="container">
            <div className="row g-5">
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                <div className="single-counterup-area-agency">
                    <div className="icon">
                    <img src="assets/images/counter/Sucessfull-projects.png" alt="agency-service" />
                    </div>
                    <div className="information">
                    <div className="counter-details">
                        <CounterUp end={1548}/>
                        <p className="disc">Successful Projects</p>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                <div className="single-counterup-area-agency">
                    <div className="icon">
                    <img src="assets/images/counter/happy-clients.png" alt="agency-service" />
                    </div>
                    <div className="information">
                    <div className="counter-details">
                        <CounterUp end={199}/>
                        <p className="disc">Happy Clients</p>
                    </div>
                    </div>
                </div>
                </div>
               
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                <div className="single-counterup-area-agency">
                    <div className="icon">
                    <img src="assets/images/counter/experience.png" alt="agency-service" />
                    </div>
                    <div className="information">
                    <div className="counter-details">
                        <CounterUp end={5}/>
                        <p className="disc">Experience</p>
                    </div>
                    </div>
                </div>
                      </div>
                       <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                <div className="single-counterup-area-agency">
                    <div className="icon">
                    <img src="assets/images/counter/experience.png" alt="agency-service" />
                    </div>
                    <div className="information">
                    <div className="counter-details">
                        <CounterUp end={5}/>
                        <p className="disc">Experience</p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        {/* tmp counterup section area end */}

    </div>
  )
}

export default Counter